import logo from '../assets/logo.svg';
import './Flower.css';
import pictures from './utils.js' // tablica ze zmiennymi ze ścieżkami do zdjęć
import { useState } from 'react';  // do pamiętania stanu indeksu zdjecia

// komponent Kwiatek
export default function Flower(){
    // liczba losowa z zakresu od 0 do 29 (jest 30 kwiatków)
    let ind =  Math.floor(Math.random()*30);

    // stan indeksu zdjęcia
    // index - zmienna z indexem kliknietego zdjęcia
    // setIndex - funkcja zmiany zmiennej index
    const [index, setIndex] = useState(ind);
    
  // funkcja inkrementująca index zdjęcia  
  let nextImg = () => {
    ind++;
    if(ind === 30){
      ind=0;
    }
    setIndex(ind);
  } 

  return (
        <div>
          {/* po kliknięciu na zdjęcie pokazuje się kolejne */}
          <img
            src={pictures[index]}
            alt="kwiatek"
            onClick={()=>nextImg()}>
          </img>
          <Logo />
        </div>
    )
  }
  
  // komponent Logo
  function Logo(){
    return (
      <>
        <img src={logo} className = "logo" alt="React logo" width="200px"  style={{animationDuration: '10s'}}></img>
        <h2 id="name">React</h2>
      </>
    )
  
  }  

  